import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Modal } from 'Core/components';
import CustomPropTypes from 'Core/prop-types';
import { selectedProduct, getPrinters } from '../production/store/selectors';
import { AppModal } from '../components/app-modals';
import PartmastersPrint from './partmasters-print';

const PartmastersPrintModal = ({ showModal, modalData, onCloseModal }) => {
  const productionData = useSelector(selectedProduct);
  const printers = useSelector(getPrinters);

  const body = () => (
    <div className="row">
      <div className="col-12 px-lg-5">
        <PartmastersPrint printers={printers} data={productionData} />
      </div>
    </div>
  );

  return (
    <Modal
      id="partmasters-print-modal"
      show={showModal}
      size="xl"
      title="Part print"
      body={body}
      footer={() => {}}
      handleClose={onCloseModal}
    />
  );
};

PartmastersPrintModal.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Production),
  onCloseModal: PropTypes.func,
};

export default AppModal(PartmastersPrintModal);
